import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

interface Result {
  data: { eventUrl: string };
}

/**
 *
 * @param {import('@tanstack/react-query').UseMutationOptions} options
 * @returns
 */
export default function useCreateMeetingLink(
  options: UseMutationOptions<Result> = {},
) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation<Result, ApiError, any, any>({
    mutationFn: async (tokenId: string) => {
      const api = new Api(args);

      const data: Result = await api.post(
        await withAcl({
          account: {
            url: '/api/v1/channels/calendar/create',
            payload: { tokenId },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/calendar/create`,
            payload: { tokenId },
          },
        }),
      );

      return data;
    },
    ...options,
  });
}
